import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=4f39437e&scoped=true"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"
import style0 from "./SelectField.vue?vue&type=style&index=0&id=4f39437e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f39437e",
  null
  
)

export default component.exports